import { tv, VariantProps } from 'tailwind-variants';

const badgeVariants = tv({
  slots: {
    base: 'px-2.5 py-1 border-solid rounded-lg flex items-center w-fit border text-sm font-medium gap-x-1.5',
    dot: 'h-1.5 w-1.5 flex self-center rounded shrink-0',
    icon: 'size-4',
  },
  variants: {
    variant: {
      green: {
        base: 'bg-success-50 border-success-200 text-success-700',
        dot: 'bg-success-400',
        icon: 'text-success-700',
      },
      red: { base: 'bg-error-50 border-error-200 text-error-500', dot: 'bg-error-500', icon: 'text-error-500' },
      yellow: {
        base: 'bg-warning-50 border-warning-200 text-warning-700',
        dot: 'bg-warning-500',
        icon: 'text-warning-700',
      },
      orange: { base: 'bg-orange-50 border-orange-700 text-orange-700', dot: 'bg-orange-600', icon: 'text-orange-700' },
      blue: { base: 'bg-blue-100 border-blue-800 text-blue-800', dot: 'text-blue-800', icon: 'text-blue-800' },
      gray: { base: 'bg-gray-50 border-gray-200 text-gray-900', dot: 'bg-gray-500', icon: 'text-gray-900' },
      brand: {
        base: 'bg-brand-50 border-brand-600 text-brand-700',
        dot: 'bg-brand-600',
        icon: 'text-brand-700',
      },
    },
  },
  defaultVariants: {
    variant: 'green',
  },
});

type BadgeVariant = VariantProps<typeof badgeVariants>['variant'];

export { badgeVariants };
export type { BadgeVariant };
